import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useRouterState } from "@tanstack/react-router";
import { OrgHeader, OrgTabNav } from "@/components/organizations";
import { RegionStats } from "@/components/regions/RegionStats";
import { useIsTablet } from "@/hooks/use-mobile";
import { PageHeader } from "@/components/layout/PageHeaderSlot";
import { useAuth } from "@/hooks/useAuth";

export const Route = createFileRoute("/(protected)/_layout/_org")({
  component: OrgLayout,
});

function OrgLayout() {
  const isTablet = useIsTablet();
  const { hasRole } = useAuth();
  const pathname = useRouterState({ select: (state) => state.location.pathname });
  const isInternalAdmin = hasRole("SUPER_ADMIN") || hasRole("SUPPORT");
  const hideOrgChrome = isInternalAdmin && pathname === "/users";

  return (
    <div className="flex flex-col gap-5 py-5 px-3">
      {!hideOrgChrome && (isTablet ? (
        <PageHeader>
          <OrgHeader tablet />
        </PageHeader>
      ) : (
        <OrgHeader />
      ))}
      {!hideOrgChrome && <RegionStats />}
      {!hideOrgChrome && <OrgTabNav />}
      <Outlet />
    </div>
  );
}
